import React, { useEffect, useState } from "react";
import { set, useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import { useMutation } from "react-query";
import axios from "axios";
import { useLocation, useNavigate } from "react-router";
import moment from "moment";
import PopupModal from "../popupmodal/PopupModal";

const UploadCustomerFormComp = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [popupState, setPopupState] = useState({
    addData: false,
  });
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useForm();

  // Function to close the modal
  const closeModal = () => {
    setIsOpen(false);
    setPopupState({
      addData: false,
    });
  };
  const handleNavigate = () => {
    navigate("/uploadViewCustomer");
    setIsOpen(false);
    setPopupState({
      addData: false,
    });
    window.location.reload();
  };

  useEffect(() => {
    if (state && state) {
      setValue("clientName", state?.clientName);
      setValue("companyName", state?.companyName);
      setValue("address", state?.address);
      setValue("phoneNumber", state?.phoneNumber);
      setValue("location", state?.location);
      setValue("state", state?.state);
      setValue("baseName", state?.baseName);
      setValue("status", state?.status);
      setValue("feedback", state?.feedback);
      setValue("date", state?.date);
      setValue("telecallerMobNo", state?.telecallerMobNo);
      setValue("assignTo", state?.assignTo);
      setValue("need", state?.need);
      setValue("leadOrWhatsappStore", state?.leadOrWhatsappStore);
    }
  }, [state, setValue]);

  const { mutate: updateMethod, isLoading: updateLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/customers/${state?.customerId}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error occurred while updating the student:", error);
        throw error;
      }
    },
    {
      onSuccess: (data) => {
        console.log("User updated successfully:", data);
        setIsOpen(true);
        setPopupState({
          addData: true,
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        // Handle any additional error actions like displaying an error message
      },
    }
  );

  // Form SUbmit
  const onSubmit = (data) => {
    let formData = {
      clientName: data?.clientName,
      companyName: data?.companyName,
      address: data?.address,
      phoneNumber: data?.phoneNumber,
      location: data?.location,
      state: data?.state,
      baseName: data?.baseName,
      designation: data?.designation,
      status: data?.status,
      feedback: data?.feedback,
      date: moment(data?.date).format("YYYY-MM-DD"),
      telecallerMobNo: data?.telecallerMobNo,
      assignTo: data?.assignTo,
      need: data?.need,
      otherNeeds: data?.otherNeeds,
      leadOrWhatsappStore: data?.leadOrWhatsappStore,
      // telecallerName: data?.telecallerName,
      // description: data?.description,

      // otherSource: data?.otherSource,
    };

    if (state && state?.customerId) {
      updateMethod(formData);
    }
  };
  return (
    <>
      <div className="customercreationbg">
        <div className="customercreationFormheader">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="customercontainer">
              <div className="customercreationheader">
                <div>
                  <label className="custlabel">Company Name</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="Company Name"
                    {...register("companyName")}
                  ></input>
                </div>
                <div>
                  <label className="custlabel">Address</label>

                  <textarea
                    className="custinput"
                    placeholder="Address"
                    {...register("address")}
                  ></textarea>
                </div>

                <div>
                  <label className="custlabel">Location</label>
                  <input
                    {...register("location")}
                    type="text"
                    className="custinput"
                    placeholder="Location"
                  />
                </div>

                <div>
                  <label className="custlabel">Base Name</label>
                  <input
                    {...register("baseName")}
                    type="text"
                    className="custinput"
                    placeholder="Base Name"
                  />
                </div>
                <div>
                  <label className="custlabel">Feedback</label>
                  <select className="custinput" {...register("feedback")}>
                    <option value="" selected>
                      Feedback
                    </option>
                    <option value="Interested">Interested</option>
                    <option value="Not Interested">Not Interested</option>
                    <option value="Callback">Callback</option>
                  </select>
                </div>
                <div className="custlable">
                  <label className="custlabel">Tele Caller Mobile NO</label>
                  <input
                    type="tel"
                    className="custinput"
                    placeholder="Tele Caller Mobile No"
                    {...register("telecallerMobNo", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                      },
                    })}
                  ></input>
                  {isSubmitted && errors.telecallermobileno && (
                    <p>Phone number must be exactly 10 digits</p>
                  )}
                </div>
                <div>
                  <label className="custlabel">Need</label>
                  <select className="custinput" {...register("need")}>
                    <option value="" disabled selected>
                      Need
                    </option>
                    <option value="CRM">CRM</option>
                    <option value="Billing software">Billing software</option>
                    <option value="ERP">ERP</option>
                    <option value="Tally">Tally</option>
                    <option value="Bank Loan">Bank Loan</option>
                    <option value="DiceKart">DiceKart</option>
                    <option value="Payroll">Payroll</option>
                    <option value="logistic software">logistic software</option>
                  </select>
                  <label className="custlabel"></label>
                  <textarea
                    {...register("otherNeeds")}
                    type="text"
                    placeholder="*non mandatory"
                    className="custominput"
                  ></textarea>
                </div>
              </div>
              <div className="customercreationheaderright">
                <div>
                  <label className="custlabel">Customer Name</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="Client Name"
                    {...register("clientName")}
                  ></input>
                </div>
                <div>
                  <label className="custlabel">Phone Number</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="Phone Number"
                    {...register("phoneNumber", {
                      required: "Phone number is required",
                      pattern: {
                        value: /^[0-9]{10}$/,
                      },
                    })}
                  ></input>
                  {isSubmitted && errors.phoneNumber && (
                    <p>Phone number must be exactly 10 digits</p>
                  )}
                </div>

                <div>
                  <label className="custlabel">State</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="State"
                    {...register("state")}
                  ></input>
                </div>

                <div>
                  <label className="custlabel">Status</label>
                  <select className="custinput" {...register("status")}>
                    <option value="">Select Status</option>
                    <option value="RNR/BC/NR">RNR/BC/NR</option>
                    <option value="INV/SWO/WRN/RBC">INV/SWO/WRN/RBC</option>
                  </select>
                </div>

                <div>
                  <label className="custlabel">Date</label>
                  <Controller
                    name="date"
                    control={control}
                    render={({ field }) => (
                      <DatePicker
                        {...field}
                        selected={
                          field.value ? moment(field.value).toDate() : null
                        }
                        onChange={(date) =>
                          field.onChange(moment(date).format("YYYY-MM-DD"))
                        }
                        dateFormat="yyyy/MM/dd"
                        placeholderText="30-12-2002"
                        showYearDropdown
                        className="custdate"
                      />
                    )}
                  />
                </div>
                <div>
                  <label className="custlabel">Assign To</label>

                  <select className="custinput" {...register("assignTo")}>
                    <option value="" disabled selected>
                      Assign To
                    </option>
                    <option value="2nd Level">2nd Level</option>
                    <option value="Kannan">Kannan</option>
                  </select>
                </div>

                <div>
                  <label className="custlabel">Lead or WhatsApp Share </label>

                  <select
                    className="custinput"
                    {...register("leadOrWhatsappStore")}
                  >
                    <option value="" disabled selected>
                      Lead or WhatsApp Share
                    </option>
                    <option value="Lead">Lead</option>
                    <option value="WhatsApp Share">WhatsApp Share</option>
                  </select>
                </div>

                {/* <div className="customselectright">
                  <label className="custlabel">Source</label>
                  <select className="custinput" {...register("base")}>
                    <option value="" disabled selected>
                      Source
                    </option>
                    <option value="Google">Google</option>
                    <option value="Youtube">Youtube</option>
                    <option value="Just Dial">Just Dial</option>
                    <option value="Telecalling">Telecalling</option>
                  </select>
                  <textarea
                    type="text"
                    placeholder="*non mandatory"
                    className="custominput"
                    {...register("otherSource")}
                  ></textarea>
                </div>

                <div>
                  <label className="custlabel">Tele Caller Name</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="Tele Caller Name"
                    {...register("telecallerName")}
                  ></input>
                </div>

                <div>
                  <label className="custlabel">Telecalling Base</label>
                  <input
                    type="text"
                    className="custinput"
                    placeholder="Telecalling Base"
                    {...register("Telecalling Base")}
                  ></input>
                </div>

                <div>
                  <div>
                    <label className="custlabel">pending from</label>

                    <select className="custinput" {...register("pending from")}>
                      <option value="" disabled selected>
                        pending from
                      </option>
                      <option value="2nd Level">2nd Level</option>
                      <option value="call status">call status</option>
                    </select>
                  </div>
                  <div></div>
                </div> */}
                <div className="">
                  <button type="submit" className="btn btn-primary btn-custom">
                    {updateLoading ? (
                      <i class="fa fa-spinner fa-spin"></i>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <PopupModal
        isOpen={isOpen}
        onClose={closeModal}
        popupState={popupState}
        message="NEW CUSTOMER HAS BEEN ADDED SUCCESSFULLY"
        onDone={handleNavigate}
        updateMessage="CUSTOMER HAS BEEN UPDATED SUCCESSFULLY"
        stateID={state && state?.customerId}
      />
    </>
  );
};

export default UploadCustomerFormComp;
